<template>
    <div>
        <template v-if="!isSingleSubscriptionView">
            <b-row class="my-2">
                <b-col cols="12" class="d-flex align-items-center">
                    <strong class="mr-2">{{ $t('fdb.filter.search') }}</strong>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="2" class="d-flex align-items-center ">
                    <b-form-select :options="statusOptions" :placeholder="$t('fdb.filter.status')" v-model="status" />
                </b-col>
                <b-col cols="12" md="2"><b-form-input :placeholder="$t('fdb.filter.order_no')" v-model="orderNumber"/></b-col>
                <b-col cols="12" md="2"><b-form-input :placeholder="$t('fdb.filter.email')" v-model="email"/></b-col>
                <b-col cols="12" md="3"><b-form-datepicker reset-button :placeholder="$t('fdb.filter.start_date')" v-model="startedAt"/></b-col>
                <b-col cols="12" md="3"><b-form-datepicker reset-button :placeholder="$t('fdb.filter.end_date')" v-model="endsAt"/></b-col>
            </b-row>
            <b-row class="my-2">
                <b-col cols="12" md="2"><b-form-select :options="termOptions" placeholder="Term" v-model="term"/></b-col>
                <b-col cols="12" md="2" v-if="subscriptionCount">{{ `${subscriptionCount} ${$t('fdb.filter.results')}` }}</b-col>
                <b-col cols="12" md="2">
                    <b-button @click="searchSubscriptionsWithParams">{{ $t('fdb.filter.search') }}</b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-table class="fdb-table" hover :items="subscriptions" :fields="fields">
                    <template #cell(status)="data">
                        <status-pill :status="data.item.statusDisplay.statusType" :text="data.item.statusDisplay.statusLabel" />
                    </template>
                    <template #cell(user_email)="data">
                        <strong>{{ data.item.user_email }}</strong>
                    </template>
                    <template #cell(order)="data">
                        <strong>{{ data.item.order }}</strong>
                    </template>
                    <template #cell(started_at)="data">
                        <strong>{{ data.item.started_at }}</strong>
                    </template>
                    <template #cell(ends_at)="data">
                        <strong>{{ data.item.ends_at }}</strong>
                    </template>
                    <template #cell(fixed_duration)="data">
                        <strong>{{ data.item.fixed_duration ? $t('fdb.filter.fixed') : $t('fdb.filter.variable') }}</strong>
                    </template>
                    <template #cell(actions)="data">
                        <icon-pill @click.native="openSingleSubscriptionView(data.item.uuid)" icon="search"></icon-pill>
                    </template>
                </b-table>
            </b-row>
        </template>
        <fdb-tab-subscriptions-single :subscription="selectedSubscription" @toggle-subscription-table="closeSingleSubscriptionView()" @cancel-subscription="cancelSubscription" @change-mileage="changeMileage" v-else />
    </div>
</template>
<script>
import { BTab, BRow, BCol, BFormInput, BTable, BButton, BFormDatepicker, BFormSelect } from 'bootstrap-vue'
import StatusPill from "../atoms/StatusPill.vue";
import IconPill from "../atoms/IconPill.vue";
import FdbTabSubscriptionsSingle from "./FdbTabSubscriptionsSingle.vue";
import StatusMixin from "../../../mixins/StatusMixin.vue";

export default {
    name: "FdbTabSubscriptions",
    components: {
        FdbTabSubscriptionsSingle,
        IconPill,
        StatusPill,
        BTab, BRow, BCol, BFormInput, BTable, BButton, BFormDatepicker, BFormSelect
    },
    mixins: [ StatusMixin ],
    props: {
        defaultEmailFilter: {
            type: String,
            default: ''
        }
    },
    watch: {
        defaultEmailFilter(value) {
            this.email = value
            this.searchSubscriptionsWithParams()
        }
    },
    data() {
        return {
            selectedSubscription: {},
            subscriptions: [],
            isSingleSubscriptionView: false,
            status: null,
            email: null,
            orderNumber: null,
            startedAt: null,
            endsAt: null,
            term: null,
            fields: [{
                key: 'status', label: this.$t('fdb.filter.status')
            }, {
               key: 'order_number', label: this.$t('fdb.filter.order_no')
            }, {
                key: 'user_email', label: this.$t('fdb.filter.email')
            }, {
                key: 'started_at', label: this.$t('fdb.filter.start_date')
            }, {
                key: 'ends_at', label: this.$t('fdb.filter.end_date')
            }, {
                key: 'fixed_duration', label: this.$t('fdb.filter.term')
            }, {
                key: 'actions', label: this.$t('fdb.actions')
            }],
            statusOptions: [
                { text: this.$t('fdb.filters.select_status'), value: null},
                { text: this.$t('cdb.subscription.status.confirmationPending'), value: "SUBSCRIPTION_INQUIRY_CONFIRMATION_PENDING" },
                { text: this.$t('cdb.subscription.status.inquiryRejected'), value: "SUBSCRIPTION_INQUIRY_REJECTED" },
                { text: this.$t('cdb.subscription.status.inquiryAccepted'), value: "SUBSCRIPTION_INQUIRY_ACCEPTED" },
                { text: this.$t('cdb.subscription.status.handoverConfirmed'), value: "SUBSCRIPTION_HANDOVER_AGREED "},
                { text: this.$t('cdb.subscription.status.active'), value: "SUBSCRIPTION_ACTIVE" },
                { text: this.$t('cdb.subscription.status.customerCancellation'), value: "SUBSCRIPTION_CUSTOMER_CANCELLATION" },
                { text: this.$t('cdb.subscription.status.finished'), value: "SUBSCRIPTION_FINISHED" },
                { text: this.$t('cdb.subscription.status.manuallyCreated'), value: "SUBSCRIPTION_MANUALLY_CREATED" },
            ],
            termOptions: [{text: this.$t('fdb.filter.term-select'), value: null}, {value: 'fixed', text: this.$t('fdb.filter.fixed')}, {value: 'variable', text: this.$t('fdb.filter.variable')}]
        }
    },
    async created() {
        await this.getSubscriptions()
    },
    methods: {
        async getSubscriptions() {
            const response = await this.$axios.get('api/v1/fleetmanager/subscriptions')
            this.subscriptions = this.mapSubscriptions(response.data)
        },
        async searchSubscriptionsWithParams() {
            const response = await this.$axios.get('api/v1/fleetmanager/subscriptions', {
                params: {
                    filters: {
                        email: this.email,
                        status: this.status,
                        order_number: this.orderNumber,
                        started_at: this.startedAt,
                        ends_at: this.endsAt,
                        term: this.term
                    }
                }
            })

            this.subscriptions = this.mapSubscriptions(response.data)
        },
        mapSubscriptions(subscriptions) {
            if (!subscriptions.length) return []
            return subscriptions.map(subscription => {
                return this.mapSubscription(subscription)
            })
        },
        mapSubscription(subscription) {
            return {
                ...subscription,
                started_at: subscription.timestamps.started_at ? this.$d(new Date(subscription.timestamps.started_at * 1000), 'short') : '',
                ends_at: subscription.timestamps.ends_at ? this.$d(new Date(subscription.timestamps.ends_at * 1000), 'short') : '',
                statusDisplay: this.calculateSubscriptionStatus(subscription),
                user_email: subscription.user?.email,
                userFullName: `${subscription.user?.first_name ?? ''} ${subscription.user?.last_name ?? ''}`,
                order_number: subscription.order_number ?? '',
                price_plan: {
                    ...subscription.price_plan,
                    price: subscription.price_plan.price ?? '',
                    currency: subscription.price_plan.currency ?? '',
                    duration: subscription.price_plan.duration ?? '',
                    mileage: subscription.price_plan.mileage ?? '',
                },
                vehicle: {
                    ...subscription.vehicle,
                    price_plans: this.mapPricePlans(subscription.vehicle.price_plans, subscription.price_plan.duration, subscription.price_plan.mileage),
                    title_image: {
                        ...subscription.vehicle.title_image,
                        url: subscription.vehicle.title_image.url ?? ''
                    },
                    model: {
                        ...subscription.vehicle.model,
                        title: subscription.vehicle.model.title ?? '',
                        brand: {
                            ...subscription.vehicle.model.brand,
                            title: subscription.vehicle.model.brand.title ?? '',
                        },
                    },
                    damage_participation: subscription.damage_participation ?? '',
                    address: {
                        ...subscription.vehicle.address,
                        name: subscription.vehicle.address.name ?? '',
                    },
                    additional_mileage_costs: {
                        ...subscription.additional_mileage_costs,
                        costs: subscription.additional_mileage_costs.costs ?? '',
                        currency: {
                            ...subscription.additional_mileage_costs.currency,
                            iso: subscription.additional_mileage_costs.currency.iso ?? ''
                        }
                    }
                }
            }
        },
        mapPricePlans(price_plans, subscriptionPlanDuration, mileage) {
            let pricePlans = price_plans.filter(pricePlan => {
                return pricePlan.minimum_duration == subscriptionPlanDuration && pricePlan.mileage !== mileage
            })
            pricePlans.sort((a, b) =>  a.mileage - b.mileage)

            return pricePlans
        },
        async openSingleSubscriptionView(uuid) {
            const response = await this.$axios.get(`api/v1/fleetmanager/subscriptions/${uuid}`)
            this.selectedSubscription = this.mapSubscription(response.data)
            this.isSingleSubscriptionView = true
        },
        closeSingleSubscriptionView() {
            this.isSingleSubscriptionView = false
            this.selectedSubscription = {}
        },
        async cancelSubscription(params) {
            const { returnType, uuid, delivery } = params
            try {
                await this.$axios.put('api/v1/checkout/update_subscription', {
                    subscription_uuid: uuid,
                    return_method: returnType,
                    return_method_pickup_costs: returnType === 'pickup' ? delivery.costs_unformatted : 0.00
                })
            } catch (error) {
                console.error(error)
            }

            await this.$axios.put('api/v1/dashboard/subscription_cancel', {
                subscription_uuid: uuid
            })

            await this.openSingleSubscriptionView(uuid)
        },
        async changeMileage(params) {
            const { mileage, uuid, price } = params
            try {
                await this.$axios.put('api/v1/dashboard/update_subscriptions_mileage', {
                    mileage: mileage,
                    subscription_uuid: uuid,
                    price: price,
                    fleetManagerId: this.fleetManagerId
                })
            }   catch (error) {
                console.error(error)
            }
            await this.openSingleSubscriptionView(uuid)
        },
    },
    computed: {
        subscriptionCount() {
            return this.subscriptions.length
        },
        fleetManagerId() {
            return this.$root.user?.state?.data?.core_user?.id
        }
    }
}
</script>
